import { Card } from "@csa/web-foundation";
import { useT } from "../i18n/index";
import type { MessageKey } from "../i18n/dictionaries";

// A calm DS1 placeholder for a reserved route — proof the design system is live in the
// new app (renders a foundation primitive, `Card`, on the codified tokens). Replaced
// by the real screen (Trust Foundation / C0) when its slice lands.
export function Placeholder({ titleKey }: { titleKey: MessageKey }) {
  const { t } = useT();
  return (
    <Card data-testid="placeholder">
      <h1>{t(titleKey)}</h1>
      <p className="muted">{t("placeholder.soon")}</p>
    </Card>
  );
}
